import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import Sortable from 'sortablejs';
import 'next/stylesheets/components/todolist';

Component('tr-todolist', {
  ready() {
    this.initSortTodo();
  },

  initSortTodo() {
    Sortable.create(this.querySelector('tr-lazy-load'), {
      group: 'todo-item',
      sort: true,
      draggable: 'tr-todo-item',
      animation: 150,
      filter: '.todo-actions',
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
      onChoose: () => {
        this.classList.add('sorting');
      },
      onUnchoose: () => {
        this.classList.remove('sorting');
      },
      onStart: () => {
        this.classList.add('sorting');
      },
      onEnd: (event) => {
        this.classList.remove('sorting');
        const $todo = $(event.item);
        $.ajax({
          url: $todo.data('sort-url'),
          data: {
            completed: $todo.hasClass('completed'),
            list_guid: $todo.closest('.todolist').data('guid'),
            prev_todo_guid: $todo.prev('.todo').data('guid'),
            next_todo_guid: $todo.next('.todo').data('guid'),
          },
        });
      },
    });
  },
});
